import { Divider, PlayCircle } from "@untitledui/icons";
import type React from "react";
import { Button } from "@/shared/components/button/button-untitledui";

type ActionButton = {
	id: string;
	label?: string;
	icon?: React.ReactNode;
	onClick?: () => void;
};

type QuestionBarProps = {
	onSave?: () => void;
	onSaveDraft?: () => void;
	actionButtons?: ActionButton[];
	saveDisabled?: boolean;
	saveLabel?: string;
	draftLabel?: string;
};

const IconButton: React.FC<
	React.ButtonHTMLAttributes<HTMLButtonElement> & { ariaLabel?: string }
> = ({ children, ariaLabel, ...props }) => (
	<button
		{...props}
		aria-label={ariaLabel}
		className="flex items-center justify-center gap-1.5 rounded-lg border border-[#D5D7DA] bg-white p-2.5 text-gray-900 shadow-sm hover:bg-gray-50 [&_svg]:text-gray-500"
		type="button"
	>
		{children}
	</button>
);

const QuestionBar: React.FC<QuestionBarProps> = ({
	onSave,
	onSaveDraft,
	actionButtons = [],
	saveDisabled,
	saveLabel = "Salvar",
	draftLabel = "Salvar rascunho",
}) => {
	const renderIcon = (btn: ActionButton) => {
		if (btn.icon) {
			return btn.icon;
		}

		switch (btn.id) {
			case "divider":
				return <Divider aria-label="Divider" color="#A4A7AE" size={20} />;
			case "play":
				return <PlayCircle aria-label="Play" color="#A4A7AE" size={20} />;
			default:
				return btn.label;
		}
	};

	return (
		<div className="sticky top-0 z-40 mb-4 border-gray-200 border-b bg-gray-100">
			<div className="flex flex-wrap items-center justify-between gap-2 rounded-xl border border-gray-200 bg-white px-3 py-2 shadow-md">
				<div className="flex flex-wrap gap-2 overflow-x-auto">
					{actionButtons.map((btn) => {
						let ariaLabel = btn.label;
						if (!ariaLabel && btn.id === "divider") {
							ariaLabel = "Divider";
						} else if (!ariaLabel && btn.id === "play") {
							ariaLabel = "Play";
						}

						return (
							<IconButton
								ariaLabel={ariaLabel}
								key={btn.id}
								onClick={btn.onClick}
							>
								{renderIcon(btn)}
							</IconButton>
						);
					})}
				</div>

				<div className="flex flex-shrink-0 gap-2">
					{onSaveDraft ? (
						<Button
							className="h-10 min-w-[80px]"
							color="secondary"
							isDisabled={saveDisabled}
							onClick={onSaveDraft}
							type="button"
						>
							{draftLabel}
						</Button>
					) : null}
					<Button
						className="h-10 min-w-[80px]"
						isDisabled={saveDisabled}
						onClick={onSave}
						type="button"
					>
						{saveLabel}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default QuestionBar;
